<template>
  <h1>其他</h1>  
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/other/Other.vue?7bc20606